import { Injectable } from '@angular/core'
import { Response } from '@angular/http'
import { Observable } from 'rxjs/Observable'

import { User } from '../../models'
import { ModelRepositoryAdapter } from '../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../model-repository/model-repository'

export class UserService extends ModelRepositoryAdapter<User> {

  constructor(private _modelRepository: ModelRepository) {
    super(_modelRepository, User)
  }

  public getUser() {
    // TODO [GitHub Issue]: This works because the url is user/me. We need to figure a way to add none REST urls
    return this.findModelsBy({}).map((users) => users[0])
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/user/user.service.ts